import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; 
import { dateToStringDate } from "../Helpers"; 

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const procurementTimeline = [
 { no: 1, activity: "Announcement", start: "March 17, 2026 00:00", end: "April 7, 2026 23:59" },
{ no: 2, activity: "Submission of EOI", start: "March 17, 2026 00:00", end: "April 7, 2026 12:00" },
{ no: 3, activity: "Shortlist Appointment", start: "April 7, 2026 00:00", end: "May 22, 2026 23:59" },
{ no: 4, activity: "Shortlist Announcement and Issuance of RFP", start: "May 25, 2026 00:00", end: "July 9, 2026 23:59" },
{ no: 5, activity: "Clarification Request Period", start: "May 25, 2026 00:00", end: "June 30, 2026 23:59" },
{ no: 6, activity: "Submission of Technical and Financial Proposals", start: "May 25, 2026 00:00", end: "July 9, 2026 12:00" },
{ no: 7, activity: "Opening of Tech Proposal", start: "July 9, 2026 13:00", end: "July 9, 2026 23:59" },
{ no: 8, activity: "Evaluation of Technical Proposals", start: "July 9, 2026 15:00", end: "August 6, 2026 23:59" },
{ no: 9, activity: "Technical Rank Announcement", start: "August 7, 2026 00:00", end: "August 7, 2026 23:59" },
{ no: 10, activity: "Opening of Financial Proposals", start: "August 26, 2026 00:00", end: "August 26, 2026 23:59" },
{ no: 11, activity: "Evaluation of Financial Proposals", start: "August 26, 2026 00:00", end: "August 28, 2026 23:59" },
{ no: 12, activity: "Combined Evaluation", start: "August 28, 2026 00:00", end: "August 28, 2026 23:59" },
{ no: 13, activity: "Final Ranking", start: "August 31, 2026 00:00", end: "August 31, 2026 23:59" },
{ no: 14, activity: "Contract Negotiation", start: "September 1, 2026 00:00", end: "September 3, 2026 23:59" },
{ no: 15, activity: "Notification of Intention of Award", start: "September 16, 2026 00:00", end: "September 16, 2026 23:59" },
{ no: 16, activity: "Standstill Period", start: "September 17, 2026 00:00", end: "September 30, 2026 23:59" },
{ no: 17, activity: "Notification of Award", start: "October 1, 2026 00:00", end: "October 1, 2026 23:59" },
{ no: 18, activity: "Contract Signing", start: "October 2, 2026 00:00", end: "October 12, 2026 23:59" },
];

function Qcqa() {
  const url_list = Config.api_domain + "/enhancement/active/";
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(true); // modal langsung terbuka

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  function getRows() {
    if (list && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/enhancement/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        {/* === POPUP / MODAL === */}
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Registration Information
          </DialogTitle>
        
          <DialogContent dividers>
            <Typography sx={{ mb: 2 }}>
              <strong>
                Bagi peserta yang berniat mengikuti seleksi silakan mendaftar ke SPSE ICB melalui link berikut:
              </strong>
              <br />
              <a
                href="https://spseicb.lkpp.go.id/spseicb/emailconfirm"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://spseicb.lkpp.go.id/spseicb/emailconfirm
              </a>
              <br /><br />
              Mohon untuk cek folder inbox dan spam setelah melakukan registrasi.
            </Typography>
        
            <Typography>
              <strong>
                For participants who intend to join the selection process, please register through SPSE ICB using the following link:
              </strong>
              <br />
              <a
                href="https://spseicb.lkpp.go.id/spseicb/emailconfirm"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://spseicb.lkpp.go.id/spseicb/emailconfirm
              </a>
              <br /><br />
              Please check your inbox and spam folder after completing the registration process.
            </Typography>
          </DialogContent>
        
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setOpen(false)}
            >
              I Understand
            </Button>
          </DialogActions>
        </Dialog>
        

        {/* === KONTEN ASLI === */}
        <h2>Geospatial Capacity Enhancement</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          The purpose of implementing Geospatial Capacity Enhancement activities is as an effort to achieve positive impacts and broader benefits in the economic, social and environmental dimensions from the existence of well-managed geospatial information.

<br></br>The objective is to enhance Indonesia's geospatial capabilities in addressing the climate crisis as part of efforts to establish the Future Geospatial Information Ecosystem through strengthening the implementation (adoption and adaptation) of the Integrated Geospatial Information Framework (IGIF).

        </p>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>
        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 500 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
          {procurementTimeline.map((row) => (
            <StyledTableRow key={row.no}>
              <StyledTableCell>{row.no}</StyledTableCell>
              <StyledTableCell>{row.activity}</StyledTableCell>
              <StyledTableCell>{row.start} (GMT+7)</StyledTableCell>
              <StyledTableCell>{row.end} (GMT+7)</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
          All schedules are based on Jakarta time (GMT +7)
        </Typography>
        <p style={{ textAlign: "justify" }}>
          The package will be processed through SPSE ICB at the link:{" "}
          <a
            href="https://spseicb.lkpp.go.id/spseicb/lelang/view/2669999"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://spseicb.lkpp.go.id/spseicb/lelang/view/2669999
          </a>
        
        </p>
      </Container>
    </div>
  );
}

export default Qcqa;
